import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { RiskMatrixTab } from './RiskMatrix';
import { POFValueTab } from './POFValue';
import { COFValueTab } from './COFValue';
import { TransitionPeriodTab } from './TransitionPeriod';

const RiskAssessmentDrawerTabs = () => {
  const [value, setValue] = useState(0);
  const tabLabels = ['Risk matrix', 'POF value', 'COF value', 'Transition period'];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', borderBottom: 1, borderColor: 'divider' }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          TabIndicatorProps={{ sx: { height: 4 } }}
          sx={{ paddingLeft: '10px' }}
        >
          {tabLabels.map((label) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ padding: 3 }}>
        {value === 0 && <RiskMatrixTab />}
        {value === 1 && <POFValueTab />}
        {value === 2 && <COFValueTab />}
        {value === 3 && <TransitionPeriodTab />}
      </Box>
    </Box>
  );
};

export default RiskAssessmentDrawerTabs;
